import { render, staticRenderFns } from "./informacion_autoridades_institucion.vue?vue&type=template&id=844b95a8&scoped=true"
import script from "./informacion_autoridades_institucion.vue?vue&type=script&lang=js"
export * from "./informacion_autoridades_institucion.vue?vue&type=script&lang=js"
import style0 from "./informacion_autoridades_institucion.vue?vue&type=style&index=0&id=844b95a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844b95a8",
  null
  
)

export default component.exports